export default __webpack_public_path__ + "static/media/25.76c78fa2.png";